/**
 * Storage utility - replacement for react-jhipster Storage
 * Provides local and session storage management
 */

class StorageManager {
  private storage: Storage;

  constructor(storage: Storage) {
    this.storage = storage;
  }

  get(key: string): string | null {
    return this.storage.getItem(key);
  }

  set(key: string, value: string): void {
    this.storage.setItem(key, value);
  }

  remove(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }
}

export const Storage = {
  local: new StorageManager(localStorage),
  session: new StorageManager(sessionStorage),
};
